import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Upload,
  Icon,
  InputNumber,
  message,
  Tooltip,
  DatePicker,
  Tabs,
  Spin,
  Select,
  Tag
} from 'antd'
import numeral from 'numeral'
import moment from 'moment'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobAiaActions'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import { actions as revisionActions } from '../../../redux/modules/revisionActions'
import Notes from '../../../components/aia/Notes'
import { filterCaseInsensitive, getModalId } from '../../../util'
import CurrencyInput from 'react-currency-input'
import history from '../../../history'
import _ from 'lodash'

import JobAiaHistoryRevision from '../../../components/jobs/aia/JobAiaHistoryRevision'

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const FormItem = Form.Item
const { TextArea } = Input
const TabPane = Tabs.TabPane
const Option = Select.Option
const propTypes = {}

class JobAias extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      activeKey: '1',
      currentNote: null,
      currentNoteId: null,
      fileList: []
    }

    // define user id (filter from dashboard)
    let userId = 0
    if (this.props.user.isAdmin) {
      userId = this.props.selectedUser && this.props.fromDashboard ? this.props.selectedUser : 0
    } else {
      userId = this.props.fromDashboard ? this.props.user.userId : 0
    }

    this.props.jobAiasRefresh({
      jobId: this.props.fromDashboard ? 0 : this.props.jobId,
      assignedToId: userId,
      fromDashboard: this.props.fromDashboard ? true : false,
      next: payload => {
        console.log('entrou')
        if (this.shouldRenderModal()) {
          const selectedAia =
            payload.data && payload.data.find(d => String(d.id) === String(this.state.currentId))
          if (selectedAia) {
            this.props.getAuditRevisions({
              targetId: selectedAia.id,
              table: 'aia'
            })
            this.props.getRevisions({
              targetId: selectedAia.id,
              table: 'aia'
            })
            this.setState({
              currentId: selectedAia.id,
              contentData: selectedAia,
              activeKey: '1'
            })

            this.props.getAiaAttachments({
              aiaId: selectedAia.id
            })
            this.props.getAiaActivities({
              aiaId: selectedAia.id
            })

            this.props.getAiaNote({ aiaId: selectedAia.id })
          }
        }
      }
    })
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.jobAiaActions.jobAias !== prevProps.jobAiaActions.jobAias
    ) {
      const highLightAia = _.filter(
        this.props.jobAiaActions.jobAias.data,
        aia => aia.id === this.props.shortcutItemId
      )
      this.handleRowClick(highLightAia[0])
      this.props.clearHighlight()
    }

    const { selectedUser } = this.props
    if (selectedUser !== prevProps.selectedUser) {
      this.props.jobAiasRefresh({
        jobId: this.props.fromDashboard ? 0 : this.props.jobId,
        assignedToId: this.props.selectedUser ? this.props.selectedUser : 0,
        fromDashboard: this.props.fromDashboard ? true : false
      })
    }
  }

  unmaksCurrency = value => {
    if (typeof value === 'string') {
      return value
        .replace('$', '')
        .split(',')
        .join('')
    } else {
      return value
    }
  }

  onTabChange = activeKey => {
    this.setState({ activeKey })
  }

  handleRowClick = row => {
    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'aia'
    })
    this.props.getRevisions({
      targetId: row.id,
      table: 'aia'
    })
    this.setState(
      {
        currentId: row.id,
        contentData: row,
        activeKey: '1'
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/aias/modal/${row.id}`)
      }
    )

    this.props.getAiaAttachments({
      aiaId: row.id
    })
    this.props.getAiaActivities({
      aiaId: row.id
    })

    this.props.getAiaNote({ aiaId: row.id })
  }

  handleAddButton = () => {
    this.setState(
      {
        modalVisible: true,
        currentId: 0,
        contentData: null,
        activeKey: '1'
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/aias/modal/0`)
        this.forceUpdate()
      }
    )
  }

  redirectToAIAs = () => {
    const { jobType, jobId } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/aias`)
    this.forceUpdate()
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState(
      { data: [], currentId: 0, modalVisible: false, activeKey: '1' },
      this.redirectToAIAs
    )
  }

  handleCreate = nextStatus => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (moment(values.aia_date).isValid())
        values.aia_date = moment(values.aia_date).format('YYYY-MM-DD hh:mm:ss')

      values.expected_pay_date = values.expected_pay_date
        ? moment(values.expected_pay_date).format('YYYY-MM-DD hh:mm:ss')
        : null
      values.job_id = this.props.jobId
      values.fromDashboard = this.props.fromDashboard
      values.selectedUser = this.props.selectedUser
      values.internal_amount = this.unmaksCurrency(values.internal_amount)
      values.vendor_amount = this.unmaksCurrency(values.vendor_amount)

      if (this.state.currentId === 0) {
        const { fileList } = this.state
        const formData = new FormData()
        fileList.forEach(file => {
          formData.append('file', file)
        })
        formData.append('job_id', this.props.jobId)
        formData.append('description', values.description)
        formData.append('internal_amount', values.internal_amount)
        formData.append('vendor_amount', values.vendor_amount)
        formData.append('expected_pay_date', values.expected_pay_date)
        formData.append('created_by_id', this.props.user.userId)
        formData.append('updated_by_id', this.props.user.userId)
        formData.append('created_date', moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
        formData.append('updated_date', moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))

        this.props.createJobAia({
          formData: formData,
          jobId: this.props.jobId
        })

        this.setState({
          fileList: []
        })

        message.warning('Creating Aia...')
      } else {
        values.status = nextStatus
        this.props.updateJobAia({
          jobId: this.props.jobId,
          aiaId: this.state.currentId,
          content: values,
          userId: this.props.user.userId
        })
        message.success('Changes saved!')
      }

      form.resetFields()
      this.setState({ contentData: null, currentId: 0, modalVisible: false }, this.redirectToAIAs)
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteJobAia({
      jobId: this.props.jobId,
      aiaId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState(
      {
        contentData: null,
        currentId: 0,
        modalVisible: false
      },
      this.redirectToAIAs
    )
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_aia')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('aiaId', this.state.currentId)

    this.props.uploadAttachment({
      formData: formData,
      aiaId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onChangeAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      aiaId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      aiaId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    this.setState({
      noteAddEditContainer: !this.state.noteAddEditContainer
    })
  }

  createNote = params => {
    this.props.createAiaNote({
      content: params,
      userId: this.props.authentication.userId,
      aiaId: this.state.currentId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editAiaNote({
      content: params,
      noteId: this.state.currentNoteId,
      aiaId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteAiaNote({
      noteId: this.state.currentNoteId,
      aiaId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  handleRevisionChange = value => {
    const form = this.props.form
    const revisions = JSON.parse(
      this.props.auditActions.revisions.data.find(x => x.id === value).json_patch
    )

    let changes = {}
    revisions.forEach(revision => {
      const fieldName = revision.path.substring(1, revision.path.length)

      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        changes[revision.path.substring(1, revision.path.length)] = revision.value.toString()
      }
    })
    changes.aia_date = moment(changes.aia_date).isValid() ? moment(changes.aia_date) : null

    changes.expected_pay_date = moment(changes.expected_pay_date).isValid()
      ? moment(changes.expected_pay_date)
      : null

    form.setFieldsValue(changes)
  }

  needsSaveButton = () => {
    const { form } = this.props
    const status = this.getStatus()
    if (/^rejected/i.test(status)) {
      return false
    }
    const fields = ['number', 'aia_date', 'internal_amount', 'vendor_amount']
    return form ? form.isFieldsTouched(fields) : false
  }

  getStatus = () => {
    const { contentData } = this.state
    return contentData && contentData.status ? contentData.status.toLowerCase() : null
  }

  generateFooter = () => {
    const status = this.getStatus()

    let returnValue

    switch (status) {
      case 'created':
        returnValue = [
          <Button key="back" type="danger" onClick={() => this.handleCreate('Rejected Internally')}>
            Rejected Internally
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => this.handleCreate('Approved Internally')}
          >
            Approved Internally
          </Button>
        ]
        break

      case 'rejected internally':
        returnValue = [
          <Button key="back" type="primary" onClick={() => this.handleCreate('Created')}>
            Save and Resubmit
          </Button>
        ]
        break

      case 'approved internally':
        returnValue = [
          <Button key="back" type="primary" onClick={() => this.handleCreate('Sent')}>
            Mark As Sent
          </Button>
        ]
        break

      case 'sent':
        returnValue = [
          <Button key="back" type="danger" onClick={() => this.handleCreate('Rejected Externally')}>
            Rejected Externally
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => this.handleCreate('Approved Externally')}
          >
            Approved Externally
          </Button>
        ]
        break

      case 'rejected externally':
        returnValue = [
          <Button key="back" type="primary" onClick={() => this.handleCreate('Created')}>
            Save and Resubmit
          </Button>
        ]
        break

      case 'approved externally':
        returnValue = [
          <Button key="submit" type="danger" onClick={() => this.handleCreate('Partially Funded')}>
            Partially Funded
          </Button>,
          <Button key="back" type="primary" onClick={() => this.handleCreate('Funded')}>
            Funded
          </Button>
        ]
        break

      case 'partially funded':
        returnValue = [
          <Button key="submit" type="danger" onClick={() => this.handleCreate('Partially Funded')}>
            Partially Funded
          </Button>,
          <Button key="back" type="primary" onClick={() => this.handleCreate('Funded')}>
            Funded
          </Button>
        ]
        break

      case 'funded':
        returnValue = [
          <Button key="submit" type="danger" onClick={() => this.handleCancel}>
            Close
          </Button>
        ]
        break

      default:
        returnValue = [
          <Button key="back" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleCreate}>
            Create
          </Button>
        ]
    }
    if (this.needsSaveButton()) {
      returnValue.push(
        <Button key="saveButton" type="primary" onClick={() => this.handleCreate('created')}>
          Save
        </Button>
      )
    }
    return returnValue
  }

  internalAmountValidator = (rule, value, callback) => {
    const form = this.props.form

    if (!value || this.unmaksCurrency(value) === 0) {
      const vendorAmount = form.getFieldValue('vendor_amount')
      if (this.unmaksCurrency(vendorAmount) === 0) {
        callback('Internal amount has to be higher than zero.')
      } else {
        callback()
      }
    } else {
      form.validateFields(['vendor_amount'], { force: true })
      callback()
    }
  }

  vendorAmountValidator = (rule, value, callback) => {
    const form = this.props.form
    if (!value || this.unmaksCurrency(value) === 0) {
      const internalAmount = form.getFieldValue('internal_amount')
      if (this.unmaksCurrency(internalAmount) === 0) {
        callback('Vendor amount has to be higher than zero.')
      } else {
        callback()
      }
    } else {
      form.validateFields(['internal_amount'], { force: true })
      callback()
    }
  }

  render() {
    const { contentData } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const firstUploadProps = {
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file)
          const newFileList = fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList
          }
        })
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file]
        }))
        return false
      },
      fileList: this.state.fileList,
      multiple: true
    }

    const { getFieldDecorator } = this.props.form

    const revisions = _.get(this.props, 'auditActions.revisions.data')

    const loadingHistoryRevisions = _.get(this.props, 'revisionActions.loading')
    const revisionsHistory = _.get(this.props, 'revisionActions.revisions')

    const loadingRevision = this.props.auditActions && this.props.auditActions.loading
    if (!this.props.jobAiaActions.jobAias) {
      return <Loader />
    }
    return (
      <div>
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title="AIA"
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={'80%'}
            footer={this.generateFooter()}
            maskClosable={false}
          >
            <Tabs activeKey={this.state.activeKey} onChange={this.onTabChange}>
              <TabPane tab="Details" key="1" defaultActiveKey="1">
                {contentData && (
                  <div className="row">
                    <div className="col-md-2">
                      <FormItem label="Number">
                        {getFieldDecorator('number', {
                          rules: [
                            {
                              required: true,
                              message: 'AIA must have a number'
                            }
                          ],
                          initialValue: contentData ? contentData.number : 0
                        })(<InputNumber />)}
                      </FormItem>
                    </div>
                    <div className="col-md-3">
                      <FormItem label="Date">
                        {getFieldDecorator('aia_date', {
                          rules: [
                            {
                              required: true,
                              message: 'AIA must have a date'
                            }
                          ],
                          initialValue: moment(contentData.aia_date).isValid()
                            ? moment(contentData.aia_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    </div>
                    <div className="col-md-2">
                      <FormItem label="Revision">
                        {loadingRevision ? (
                          <Spin size="small" />
                        ) : (
                          <Select
                            defaultValue={
                              revisions && revisions.length > 0
                                ? revisions[revisions.length - 1].id
                                : null
                            }
                            onChange={this.handleRevisionChange}
                          >
                            {revisions &&
                              revisions.map(revision => (
                                <Option key={revision.id} value={revision.id}>
                                  {revision.revision}
                                </Option>
                              ))}
                          </Select>
                        )}
                      </FormItem>
                    </div>
                    <div className="col-3">
                      <FormItem label="Status">
                        <Tag color="blue">{contentData.status}</Tag>
                      </FormItem>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-md-12">
                    <FormItem label="Description">
                      {getFieldDecorator('description', {
                        initialValue: contentData ? contentData.description : ''
                      })(<TextArea />)}
                    </FormItem>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <FormItem label="Internal Amount">
                      {getFieldDecorator('internal_amount', {
                        rules: [
                          {
                            required: false,
                            message: 'Internal amount has to be higher than zero.'
                          }
                        ],
                        initialValue: contentData ? contentData.internal_amount : 0
                      })(<CurrencyInput className="ant-input" precision="2" prefix="$" />)}
                    </FormItem>
                  </div>
                  <div className="col-md-3">
                    <FormItem label="Vendor Amount">
                      {getFieldDecorator('vendor_amount', {
                        rules: [
                          {
                            required: false,
                            message: 'Vendor amount has to be higher than zero.'
                          }
                        ],
                        initialValue: contentData ? contentData.vendor_amount : 0
                      })(<CurrencyInput className="ant-input" precision="2" prefix="$" />)}
                    </FormItem>
                  </div>
                  <div className="col-3">
                    <FormItem label="Expected Pay Date">
                      {getFieldDecorator('expected_pay_date', {
                        rules: [
                          {
                            required: true,
                            message: 'Expected pay date should not be blank.'
                          }
                        ],
                        initialValue:
                          contentData && contentData.expected_pay_date
                            ? moment(contentData.expected_pay_date)
                            : null
                      })(<DatePicker />)}
                    </FormItem>
                  </div>
                  <div className="col-3">
                    {!contentData && (
                      <FormItem label="Files">
                        {getFieldDecorator('first_files', {})(
                          <Upload {...firstUploadProps}>
                            <Button>
                              <Icon type="upload" /> Upload
                            </Button>
                          </Upload>
                        )}
                      </FormItem>
                    )}
                  </div>
                </div>
                {contentData && (
                  <div className="row">
                    <div className="col-md-12">
                      <Notes
                        notes={
                          this.props.jobAiaActions.aiaNotes &&
                          this.props.jobAiaActions.aiaNotes.data
                        }
                        handleToggleNoteEditArea={this.handleToggleNoteEditArea}
                        noteAddEditContainer={this.state.noteAddEditContainer}
                        userId={this.props.user.userId}
                        createNote={this.createNote}
                        currentNote={this.state.currentNote}
                        handleRowNoteClick={this.handleRowNoteClick}
                        updateNote={this.updateNote}
                        deleteNote={this.deleteNote}
                      />
                    </div>
                  </div>
                )}
                {contentData && (
                  <FilesUploadContainer>
                    <div className="row">
                      <div className="col-md-6">
                        <h6>
                          <Icon type="file" /> AIA Files
                        </h6>
                      </div>
                      <div className="col-md-6 text-right">
                        {this.props.jobAiaActions &&
                          this.props.jobAiaActions.uploadingAttachment && (
                            <div className="text-success">
                              <Icon type="loading" /> Uploading File(s)
                            </div>
                          )}
                        {this.props.jobAiaActions &&
                          this.props.jobAiaActions.deletingAttachment && (
                            <div className="text-danger">
                              <Icon type="loading" /> Deleting File(s)
                            </div>
                          )}
                      </div>
                    </div>
                    {this.props.jobAiaActions.jobAiaAttachments &&
                      this.props.jobAiaActions.jobAiaAttachments.data.length > 0 && (
                        <Spin spinning={this.props.jobAiaActions.loadingAttachments}>
                          <ReactTable
                            defaultPageSize={5}
                            data={this.props.jobAiaActions.jobAiaAttachments.data}
                            getTrProps={(state, rowInfo, column, instance) => ({
                              onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                            })}
                            columns={[
                              {
                                Header: 'Attached Files',
                                columns: [
                                  {
                                    Header: 'Filename',
                                    id: 'filename',
                                    accessor: 'filename',
                                    Cell: d => (
                                      <Tooltip title={d.original.filename}>
                                        {d.original.filename}
                                      </Tooltip>
                                    )
                                  },
                                  {
                                    Header: 'Description',
                                    id: 'description',
                                    accessor: 'description',
                                    Cell: d => (
                                      <Tooltip title={d.original.description}>
                                        {d.original.description}
                                      </Tooltip>
                                    )
                                  },
                                  {
                                    Header: 'Created By',
                                    id: 'created_by',
                                    accessor: d =>
                                      `${d.created_by_first_name} ${d.created_by_last_name}`,
                                    width: 160,
                                    Cell: d => {
                                      const r = `${d.original.created_by_first_name} ${
                                        d.original.created_by_last_name
                                      }`
                                      return <Tooltip title={r}>{r}</Tooltip>
                                    }
                                  },
                                  {
                                    Header: 'Updated By',
                                    id: 'updated_by',
                                    accessor: d =>
                                      `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                                    width: 160,
                                    Cell: d => {
                                      const r = `${d.original.updated_by_first_name} ${
                                        d.original.updated_by_last_name
                                      }`
                                      return <Tooltip title={r}>{r}</Tooltip>
                                    }
                                  },
                                  {
                                    Cell: row => (
                                      <Tooltip
                                        placement="left"
                                        title="Open this file on a new window"
                                      >
                                        <a target="_blank" href={row.original.signedUrl}>
                                          <Icon type="export" className="fontSize20" />
                                        </a>
                                      </Tooltip>
                                    ),
                                    maxWidth: 35
                                  }
                                ]
                              }
                            ]}
                            defaultSorted={[
                              {
                                id: 'id',
                                desc: true
                              }
                            ]}
                            className="-striped -highlight"
                          />
                        </Spin>
                      )}
                    {this.state.attachmentDetailsVisible && (
                      <EditAttachmentContainer>
                        <EditAttachmentTitle>
                          <Icon type="edit" /> Edit Attachment Area
                        </EditAttachmentTitle>
                        <div>
                          <EditingFileContainer>
                            <Icon type="file" /> {this.state.attachmentName}
                          </EditingFileContainer>
                        </div>
                        <div className="row">
                          <div className="col-md-10">
                            <TextArea
                              placeholder="Describe the attachment..."
                              rows={4}
                              onChange={this.onDescriptionChange}
                              value={this.state.attachmentDescription}
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-row mt-2">
                          <Button onClick={this.onChangeAttachmentDescription}>
                            <Icon type="save" /> OK
                          </Button>{' '}
                          <Popconfirm
                            title="Are you sure you want to delete this attachment?"
                            onConfirm={this.confirmAttachmentDelete}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button type="danger" icon="delete" className="ml-2">
                              {' '}
                              DELETE
                            </Button>
                          </Popconfirm>
                        </div>
                      </EditAttachmentContainer>
                    )}
                    <br />
                    <div>Upload AIA File(s)</div>
                    <br />
                    <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                      <Button>
                        <Icon type="upload" /> Upload
                      </Button>
                    </Upload>
                  </FilesUploadContainer>
                )}
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={this.confirmDelete}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  {contentData && <Button type="danger" icon="delete" />}
                </Popconfirm>
              </TabPane>
              {contentData && (
                <TabPane tab="History" key="2">
                  <JobAiaHistoryRevision
                    revisionsHistory={revisionsHistory}
                    loadingHistoryRevisions={loadingHistoryRevisions}
                  />
                </TabPane>
              )}
            </Tabs>
          </Modal>
        )}
        <div className="jobsBar">
          AIA's
          {!this.props.fromDashboard && (
            <div className="jobsBarAdd">
              <i className="fa fa-plus-square" aria-hidden="true" />
              &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
                ADD AIA
              </div>
            </div>
          )}
        </div>
        {this.props.jobAiaActions.jobAias &&
          !this.props.fromDashboard && (
            <ReactTable
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.handleRowClick(rowInfo.original)
              })}
              data={this.props.jobAiaActions.jobAias.data}
              columns={[
                {
                  columns: [
                    {
                      Header: 'AIA Number',
                      id: 'number',
                      accessor: 'number',
                      Cell: d => <Tooltip title={d.original.number}>{d.original.number}</Tooltip>,
                      maxWidth: 90,
                      className: 'textAlignCenter'
                    },
                    {
                      Header: 'Internal Amount',
                      id: 'internal_amount',
                      accessor: 'internal_amount',
                      Cell: d => {
                        const r = numeral(d.original.internal_amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 120
                    },
                    {
                      Header: 'Vendor Amount',
                      id: 'vendor_amount',
                      accessor: 'vendor_amount',
                      Cell: d => {
                        const r = numeral(d.original.vendor_amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 120
                    },
                    {
                      Header: 'Total Amount',
                      id: 'total_amount',
                      accessor: d => numeral(d.internal_amount + d.vendor_amount).format('$0,0.00'),
                      Cell: d => {
                        const r = numeral(
                          d.original.internal_amount + d.original.vendor_amount
                        ).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 120
                    },
                    {
                      Header: 'Assigned To',
                      id: 'assigned_to_name',
                      accessor: d => {
                        let r = ''
                        if (d.assigned_to_role_name) {
                          r = d.assigned_to_role_name
                        } else if (d.assigned_to_first_name) {
                          r = `${d.assigned_to_first_name} ${d.assigned_to_last_name}`
                        } else if (!d.assigned_to_first_name && !d.assigned_to_role_name) {
                          r = `N/A`
                        }

                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      Cell: d => {
                        let r = ''
                        if (d.original.assigned_to_role_name) {
                          r = d.original.assigned_to_role_name
                        } else if (d.original.assigned_to_first_name) {
                          r = `${d.original.assigned_to_first_name} ${
                            d.original.assigned_to_last_name
                          }`
                        } else if (
                          !d.original.assigned_to_role_name &&
                          !d.original.assigned_to_first_name
                        ) {
                          r = 'N/A'
                        }

                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      maxWidth: 110
                    },
                    {
                      Header: 'Description',
                      id: 'description',
                      accessor: 'description',
                      Cell: d => (
                        <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                      )
                    },
                    {
                      Header: 'Created By',
                      id: 'created_by',
                      accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                      width: 160,
                      Cell: d => {
                        const r = `${d.original.created_by_first_name} ${
                          d.original.created_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Updated By',
                      id: 'updated_by',
                      accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                      width: 160,
                      Cell: d => {
                        const r = `${d.original.updated_by_first_name} ${
                          d.original.updated_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Status',
                      accessor: 'status',
                      maxWidth: 150
                    }
                  ]
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          )}
        {this.props.jobAiaActions.jobAias &&
          this.props.fromDashboard && (
            <ReactTable
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              getTdProps={(state, rowInfo, column, instance) => ({
                onClick: e => {
                  if (column.Header !== 'Job') {
                    this.handleRowClick(rowInfo.original)
                  }
                }
              })}
              data={this.props.jobAiaActions.jobAias.data}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Job',
                      accessor: 'job_id',
                      Cell: row => {
                        const r = `${row.original.job_id} - ${row.original.job_name}`
                        return (
                          <Tooltip title={r}>
                            <Link to={`/jobView/${row.original.job_id}/${row.original.job_type}`}>
                              {r}
                            </Link>
                          </Tooltip>
                        )
                      },
                      minWidth: 150
                    },
                    {
                      Header: 'AIA Number',
                      id: 'number',
                      accessor: 'number',
                      Cell: d => <Tooltip title={d.original.number}>{d.original.number}</Tooltip>,
                      maxWidth: 90,
                      className: 'textAlignCenter'
                    },
                    {
                      Header: 'Internal Amount',
                      id: 'internal_amount',
                      accessor: 'internal_amount',
                      Cell: d => {
                        const r = numeral(d.original.internal_amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 120
                    },
                    {
                      Header: 'Vendor Amount',
                      id: 'vendor_amount',
                      accessor: 'vendor_amount',
                      Cell: d => {
                        const r = numeral(d.original.vendor_amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 120
                    },
                    {
                      Header: 'Total Amount',
                      id: 'total_amount',
                      accessor: d => numeral(d.internal_amount + d.vendor_amount).format('$0,0.00'),
                      Cell: d => {
                        const r = numeral(
                          d.original.internal_amount + d.original.vendor_amount
                        ).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 120
                    },
                    {
                      Header: 'Assigned To',
                      id: 'assigned_to_name',
                      accessor: d => {
                        let r = ''
                        if (d.assigned_to_role_name) {
                          r = d.assigned_to_role_name
                        } else if (d.assigned_to_first_name) {
                          r = `${d.assigned_to_first_name} ${d.assigned_to_last_name}`
                        } else if (!d.assigned_to_first_name && !d.assigned_to_role_name) {
                          r = `N/A`
                        }

                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      Cell: d => {
                        let r = ''
                        if (d.original.assigned_to_role_name) {
                          r = d.original.assigned_to_role_name
                        } else if (d.original.assigned_to_first_name) {
                          r = `${d.original.assigned_to_first_name} ${
                            d.original.assigned_to_last_name
                          }`
                        } else if (
                          !d.original.assigned_to_role_name &&
                          !d.original.assigned_to_first_name
                        ) {
                          r = 'N/A'
                        }

                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      maxWidth: 110
                    },
                    {
                      Header: 'Description',
                      id: 'description',
                      accessor: 'description',
                      Cell: d => (
                        <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                      )
                    },
                    {
                      Header: 'Status',
                      accessor: 'status',
                      maxWidth: 150
                    }
                  ]
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          )}
      </div>
    )
  }
}

const mapStateToProps = (
  { jobAiaActions, authentication, auditActions, revisionActions },
  ownProps
) => ({
  jobAiaActions,
  authentication,
  auditActions,
  revisionActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, auditActions, revisionActions), dispatch)
})

JobAias.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobAias)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobAias.js